import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from './reducers';
import * as settings from '../settings';

const configureStore = () => {
  const middlewares = [thunk];
  if (!settings.IS_PROD) {
    middlewares.push(createLogger());
  }

  const store = createStore(rootReducer, applyMiddleware(...middlewares));

  return store;
};

export default configureStore;
